import { BehaviorSubject, Observable } from 'rxjs';
import { Guard } from 'src/core-lib/misselaineous/guards';
import { UmbracoImage } from 'src/core-lib/umbraco/umbraco-image.model';
import { ImageModel } from './models/image.model';

export class ImageLoader implements ImageModel {
    private static LOADED: string[] = [];
    private source: BehaviorSubject<string>
    private href: string = '';

    public url: string;
    public queryObject?: { [key: string]: string; };
    public aspectRatio?: string;
    public source$: Observable<string>;

    constructor(image: ImageModel, private INITIAL_URL: string, private LOADING_URL: string, private FALLBACK_URL: string) {
        this.source = new BehaviorSubject<string>(this.INITIAL_URL);
        this.source$ = this.source.asObservable();
        Object.assign(this, image);
        if (this.url !== null && this.url !== undefined) {
            this.href = ImageMapper.Url(this);
        }
        this.source.next(this.LOADING_URL);
        this.load();
    }

    load() {
        let src;
        if (!ImageLoader.LOADED.some(url => url === this.href)) {
            this.loadImage()
                .then(() => src = this.href)
                .then(() => ImageLoader.LOADED.push(this.href))
                .catch(() => src = this.FALLBACK_URL)
                .finally(() => this.source.next(src));
        } else {
            this.source.next(this.href);
        }
    }

    private loadImage(): Promise<string> {
        const url = this.href;
        return new Promise<string>((resolve, reject) => {
            const image = new Image();
            image.onload = () => resolve(url);
            image.onerror = (err) => reject(this.FALLBACK_URL);

            if (url === undefined || url === null) {
                reject();
            }
            image.src = url;
        });
    }
}


export class ImageMapper {

    static Url(image: ImageModel | UmbracoImage | string, query?: object): string {
        if (image == null) {
            return;
        }
        if ((image as ImageModel).url != null) {
            const _image = image as ImageModel;
            return ImageMapper.GetUrl(_image.url, ImageMapper.getQueryParams(Object.assign(_image.queryObject, query)));
        } else if ((image as UmbracoImage).imageUrl != null) {
            const _image = image as UmbracoImage;
            return ImageMapper.GetUrl(_image.imageUrl, ImageMapper.getQueryParams(ImageMapper.getQuery(_image, query)));
        } else if (typeof image === 'string') {
            return ImageMapper.GetUrl(image, ImageMapper.getQueryParams(query));
        }
    }

    private static GetUrl(url: string, query?: string): string {
        const someQuery = query != null && query !== '';
        if (url.startsWith('data')) {
            return url;
        } else if (someQuery) {
            var imageUrl = new URL(url, window.location.href);
            // we let query parameters win over existing url parameters
            let combined = new URLSearchParams({
                ...Object.fromEntries(imageUrl.searchParams),
                ...Object.fromEntries(typeof query !== 'string' ? query : new URLSearchParams(query))
              });

              imageUrl.search = combined.toString();

            return imageUrl.toString();
        }
        return url;
    }


    private static getQuery(use: UmbracoImage | string, query?: object): Object {
        if (Guard.is.nullOrUndefined(query)) {
            query = {};
        }
        if (typeof use !== 'string' && use.focalPoint != null) {
            Object.assign(query, { center: `${use.focalPoint.y},${use.focalPoint.x}` });
        }
        return query;
    }


    private static getQueryParams(queryObject: object): string {
        try {
            const keys = Object.keys(queryObject);
            return keys.filter(key => queryObject[key] != null).map(key => `${key}=${queryObject[key]}`).join('&');
        } catch {
            return null;
        }
    }
}
